import type { IconName } from "components/Icon";

import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { TransientResultFile, TransientResultIteration } from "../lib/formatJobResults";

import { TransientJobResultRoomList } from "./TransientJobResultRoomList";

type TransientJobResultIterationProps = {
  fileIcon?: (file: TransientResultFile) => { color: string; iconName: IconName };
  isSelected: (key: string) => boolean;
  iteration: TransientResultIteration;
  onSetMany: (keys: string[], shouldSelect: boolean) => void;
  onToggle: (key: string) => void;
  search: string;
};

export const TransientJobResultIterationGroup = ({
  fileIcon,
  isSelected,
  iteration,
  onSetMany,
  onToggle,
  search,
}: TransientJobResultIterationProps) => {
  const { t } = useTranslation();
  return (
    <div>
      <Stack className="gap-2">
        <span className="font-ds-headline-sm text-lds-foreground-heading-initial">
          {t("Execution.transient.jobDetails.iteration", { count: iteration.iteration })}
        </span>
        <span className="text-lds-foreground-muted font-ds-body-regular-md">
          {t("Execution.transient.jobDetails.roomCount", { count: iteration.files.length })}
        </span>
      </Stack>
      <TransientJobResultRoomList
        fileIcon={fileIcon}
        files={iteration.files}
        folderName={iteration.folderName}
        isSelected={isSelected}
        onSetMany={onSetMany}
        onToggle={onToggle}
        search={search}
      />
    </div>
  );
};
